import { FormBase } from 'core/components';

export default class FacilityCreateForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'file',
                    label: 'FACILITY.UPLOAD.FILE_LABEL',
                    placeholder: 'FACILITY.UPLOAD.FILE_PLACEHOLDER',
                    type:'file'
                }
            ],
        };
    }
}
